module.exports = __webpack_public_path__ + "img/TAM4000_1-1.b60b9c74.png";